module.exports = __webpack_public_path__ + "media/applicants/app-store-d780a636.png";